<template>
  <div>
    <b-alert variant="info" show>
     {{ objeto.item.Observaciones }}
    </b-alert>
  </div>
</template>
<script>
export default {
  name: "TablaDetalleHistorialSolicitud",
  props: {
    objeto: Object
  },
};
</script>



// WEBPACK FOOTER //
// src/components/common/TablaDetalleHistorialSolicitud.vue